import type { DuplicateRequestResponse } from "@nlc/shared-types";
import type { DefaultValues, UseFormReset } from "react-hook-form";

import { BriefCreatorTypeEnum } from "@nlc/shared-types";

import type { CreateWebsiteDesignRequestFormData } from "../components/useCreateWebsiteDesignRequestForm";

import {
  mapAttachmentsByCategory,
  useDuplicateRequest,
} from "../../shared/useDuplicateRequest";

function mapDuplicateResponseToFormData(
  data: DuplicateRequestResponse,
): DefaultValues<CreateWebsiteDesignRequestFormData> {
  const briefCreatorType = data.briefText
    ? BriefCreatorTypeEnum.DETAILED
    : BriefCreatorTypeEnum.SINGLE;

  return {
    assets: mapAttachmentsByCategory(data.attachments, "asset"),
    brandId: data.brandId || undefined,
    briefCreatorDetailed: {
      additionalGuidelines:
        data.magicalBriefCreator?.additionalGuidelines || "",
      brandGuidelines: data.magicalBriefCreator?.brandGuidelines || "",
      creativeGoal: data.magicalBriefCreator?.creativeGoals || "",
      finalBrief: data.briefText || "",
      finalBriefHTML: data.briefText || "",
      scope: data.magicalBriefCreator?.scope || "",
      textsForDesign: data.magicalBriefCreator?.textForDesign || "",
    },
    briefCreatorSingle: {
      requestDescription: data.description || "",
      requestDescriptionHTML: data.description || "",
      textsForDesign: data.textForDesign || "",
      textsForDesignHTML: data.textForDesign || "",
    },
    briefCreatorType,
    collaboratorIds: data.collaboratorIds || [],
    creativeDirection: data.creativeDirection || undefined,
    designComplexityId: data.complexityId || undefined,
    designTypeId: data.designTypeId ?? undefined,
    inspirations: mapAttachmentsByCategory(data.attachments, "example"),
    preferredDesignerIds: data.preferredDesignerIds || [],
    preferredFileTypes: data.preferredFileType || "",
    requestName: data.name || "",
    sizesNeeded: data.sizesNeeded || "",
  };
}

interface UseDuplicateWebsiteDesignRequestProps {
  reset: UseFormReset<CreateWebsiteDesignRequestFormData>;
}

export function useDuplicateWebsiteDesignRequest({
  reset,
}: UseDuplicateWebsiteDesignRequestProps) {
  return useDuplicateRequest<CreateWebsiteDesignRequestFormData>({
    mapDuplicateResponseToFormData,
    reset,
  });
}
